export default [
    {
        path: '/teacher-panel-settings',
        name: 'teacher-panel-settings',
        component: () => import('./pages/Index'),
        meta: {
            title: 'Configurações do Painel Docente',
            icon: 'mdi-cog',
            breadcrumbs: [
                { text: 'Professores', to: '/teachers' },
                { text: 'Configurações do Painel Docente', disabled: true }
            ]
        }
    }
]
